// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Icon$OrcaPaymentPage from "./Icon.bs.js";
import * as RenderIf$OrcaPaymentPage from "./Components/RenderIf.bs.js";
import * as CardUtils$OrcaPaymentPage from "./CardUtils.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "./Utilities/RecoilAtoms.bs.js";
import * as PaymentUtils$OrcaPaymentPage from "./Utilities/PaymentUtils.bs.js";

function TabCard(props) {
  var isActive = props.isActive;
  var paymentOption = props.paymentOption;
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  var match$1 = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.optionAtom);
  var layoutClass = CardUtils$OrcaPaymentPage.getLayoutClass(match$1.layout);
  var setSelectedOption = Recoil.useSetRecoilState(RecoilAtoms$OrcaPaymentPage.selectedOptionAtom);
  var match$2 = React.useMemo((function () {
          if (isActive) {
            return [
                    "Tab--selected",
                    "TabLabel--selected",
                    "TabIcon--selected"
                  ];
          } else {
            return [
                    "",
                    "",
                    ""
                  ];
          }
        }), [isActive]);
  var match$3 = PaymentUtils$OrcaPaymentPage.getDisplayNameAndIcon(match$1.customMethodNames, paymentOption.paymentMethodName, paymentOption.displayName, paymentOption.icon);
  var icon = match$3[1];
  var onClick = function (param) {
    setSelectedOption(function (param) {
          return paymentOption.paymentMethodName;
        });
  };
  return React.createElement("button", {
              className: "Tab " + match$2[0] + " flex flex-col animate-slowShow",
              style: {
                cursor: "pointer",
                minWidth: "5rem",
                padding: match.themeObj.spacingUnit,
                width: "100%",
                overflowWrap: "anywhere"
              },
              disabled: match$1.readOnly,
              type: "button",
              onClick: onClick
            }, React.createElement("div", {
                  className: "TabIcon " + match$2[2] + " relative"
                }, icon !== undefined ? Caml_option.valFromOption(icon) : React.createElement(Icon$OrcaPaymentPage.make, {
                        name: "default-card",
                        size: 19
                      }), React.createElement(RenderIf$OrcaPaymentPage.make, {
                      condition: layoutClass.showCheckedIconForSelection && isActive,
                      children: React.createElement("div", {
                            className: "TabSelectionIcon absolute"
                          }, React.createElement(Icon$OrcaPaymentPage.make, {
                                name: "checked-selection",
                                size: 14
                              }))
                    })), React.createElement("div", {
                  className: "TabLabel " + match$2[1]
                }, paymentOption.paymentMethodName === "card" ? match.localeString.card : match$3[0]));
}

var make = TabCard;

export {
  make ,
}
/* react Not a pure module */
